import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';
// 引入自定义的语言配置文件
import zh from './config/zh';
import en from './config/en';
Vue.use(VueI18n);


const messages = {
  en: {
    ...en,
  },
  zh: {
    ...zh,
  },
};

// 创建vue-i18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages: messages,
});

locale.i18n((key, value) => i18n.t(key, value));

export default i18n;
